import React from "react";

function SvgIcMapPoi106(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M20.326 22.244L16 19.101l-4.326 3.143 1.652-5.086L9 14.015h5.347L16 8.93l1.652 5.086H23l-4.326 3.143 1.652 5.086zM16 4.074L5 12.096l4.201 12.978h13.597L27 12.096 16 4.074z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi106;
